import { WebViewParams } from '@types'
import {
  TrackerConfiguration,
  FormTrackingConfiguration,
} from '@tino-frontend/analytics'
import { ApiAdapter } from '@tino-frontend/adapters'
import { SentryConfig } from 'services/sentry-config.service'

export function analyticsCompose(
  endpoint: string,
  env: string
): [
  trackerId: string,
  endpoint: string,
  configuration: TrackerConfiguration,
  formTrackingConfiguration?: FormTrackingConfiguration,
] {
  const queryString = window.location.search
  const isReactNativeWebView = window.ReactNativeWebView
  const urlSearchParams = new URLSearchParams(queryString)
  const urlTrackerIdParam =
    urlSearchParams.get('tracker_id') ||
    urlSearchParams.get('trackerId') ||
    'default'

  function urlParams() {
    if (
      !isReactNativeWebView &&
      urlTrackerIdParam === WebViewParams.IS_TINO_WEBVIEW
    ) {
      return 'default'
    }
    return urlTrackerIdParam
  }

  return [
    urlParams(),
    endpoint,
    {
      appId: `webapp-${env}`,
      platform: 'web',
      devMode: env === 'loc',
      enabledCookieExtract: true,
      contexts: {
        webPage: true,
      },
    },
  ]
}

export function isErrorStatus(status: number) {
  const value = status.toString()

  // Includes 4xx and 5xx errors
  return /^[45]\d{2}$/.test(value)
}

export function analyticsSetInterceptor(adapters: ApiAdapter[]) {
  const request = (res: any) => {
    const { url } = res.config || { url: '' }
    const status = res.status || res.response?.status

    const sentry = new SentryConfig()
    const isValidStatus =
      (status && isErrorStatus(status)) || status === undefined

    if (isValidStatus && sentry.shouldCaptureRequestError(status, url)) {
      sentry.captureRequestError(res)
    }

    return res?.data
  }

  const reject = (res: any) => {
    request(res)
    throw res?.response?.data
  }

  adapters.forEach((adapter) =>
    adapter.setInterceptorResponseHeaders(request, reject)
  )
}
